import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatExpansionModule } from "@angular/material/expansion";
import { IonicComponentsModule } from "src/components/ionic-components.module";
import { TranslatePipe, TranslateDirective } from "@ngx-translate/core";
import { EmptyStateComponent } from "./empty-state/empty-state.component";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { EditorModule } from "@tinymce/tinymce-angular";
import { NgxEchartsModule } from "ngx-echarts";
import { PipesModule } from "src/pipes/pipes.module";
import { FilteromponentsModule as FilteComponentsModule } from "../filter components/filter-components.module";
import { FormComponentModule } from "../form-components/form-component.module";
import { ListSelectableModule } from "../list-selectable/list-selectable.module";
import { AccountingEntitiesListComponent } from "./accounting-entities-list/accounting-entities-list.component";
import { AccountingGenerateComponent } from "./accounting-generate/accounting-generate.component";
import { AccountingNotesListComponent } from "./accounting-notes-list/accounting-notes-list.component";
import { AddressSearchComponent } from "./address-search/address-search.component";
import { AddressesForwardListComponent } from "./addresses-forward-list/addresses-forward-list.component";
import { AlarmsHistoryListComponent } from "./alarms-history-list/alarms-history-list.component";
import { CommunicationListComponent } from "./communication-list/communication-list.component";
import { DefaultSupervisionComponent } from "./default-supervision/default-supervision.component";
import { DeletedContentComponent } from "./deleted-content/deleted-content.component";
import { EnvironmentSearchComponent } from "./environment-search/environment-search.component";
import { ErrorContentComponent } from "./error-content/error-content.component";
import { FooterComponent } from "./footer/footer.component";
import { GaugeCircularComponent } from "./gauge-circular/gauge-circular.component";
import { GeneralInfoPopupAlarmComponent } from "./general-info-popup-alarm/general-info-popup-alarm.component";
import { HomeAsideContentComponent } from "./home-aside-content/home-aside-content.component";
import { InfoPopupAlarmComponent } from "./info-popup-alarm/info-popup-alarm.component";
import { IpVerificationStatusComponent } from "./ip-verification-status/ip-verification-status.component";
import { ItemHistoryListComponent } from "./item-history-list/item-history-list.component";
import { ItemNotificationListComponent } from "./item-notification-list/item-notification-list.component";
import { ListAlarmsComponent } from "./list-alarms/list-alarms.component";
import { ListEnvironmentOpenDoorComponent } from "./list-environment-open-door/list-environment-open-door.component";
import { LoadControlFormComponent } from "./load-control-form/load-control-form.component";
import { LoadControlGroupFormComponent } from "./load-control-group-form/load-control-group-form.component";
import { LoadControlListComponent } from "./load-control-list/load-control-list.component";
import { LoadFormComponent } from "./load-form/load-form.component";
import { LoaderCircularComponent } from "./loader-circular/loader-circular.component";
import { LoginAccessPlantComponent } from "./login-access-plant/login-access-plant.component";
import { MenuWebComponent } from "./menu-web/menu-web.component";
import { MenuWebDigitalPlaceComponent } from "./menu-web-digital-place/menu-web-digital-place.component";
import { NoContentComponent } from "./no-content/no-content.component";
import { NumericKeypadComponent } from "./numeric-keypad/numeric-keypad.component";
import { OptionsLogComponent } from "./options-log/options-log.component";
import { OptionsPlantSpecificComponent } from "./options-plant-specific/options-plant-specific.component";
import { OptionsSettingsGenericComponent } from "./options-settings-generic/options-settings-generic.component";
import { OptionsVersionComponent } from "./options-version/options-version.component";
import { PlantListComponent } from "./plant-list/plant-list.component";
import { BuildingListComponent } from "./building-list/building-list.component";
import { PlantComponent } from "./plant/plant.component";
import { BuildingComponent } from "./building/building.component";
import { ReporthtmlFormComponent } from "./reporthtml-form/reporthtml-form.component";
import { ReporthtmlListComponent } from "./reporthtml-list/reporthtml-list.component";
import { ReporthtmlComponent } from "./reporthtml/reporthtml.component";
import { SearchComboComponent } from "./search-combo/search-combo.component";
import { StructureTableAnagraphComponent } from "./structure-table-anagraph/structure-table-anagraph.component";
import { SupervisionComponent } from "./supervision/supervision.component";
import { TimeSelectorComponent } from "./time-selector/time-selector.component";
import { ToggleWithTextComponent } from "./toggle-with-text/toggle-with-text.component";
import { GenericTableComponent } from "./generic-table/generic-table.component";
import { HistoryAccessStateIconComponent } from "./history-access-state-icon/history-access-state-icon.component";
import { ReservationStateIconComponent } from "./reservation-state-icon/reservation-state-icon.component";
import { TreeNodeComponent } from "./tree-node/tree-node.component";
import { WarningDeviceAdminPasswordComponent } from "./warning-device-admin-password/warning-device-admin-password.component";
import { WeekDayChooseComponent } from "./week-day-choose/week-day-choose.component";
import { EnvironmentItemComponent } from "./environment-item/environment-item.component";
import { ToolbarDPComponent } from "./toolbar-dp/toolbar-dp.component";
import { ColorPickerDirective } from "ngx-color-picker";
import { FooterDPComponent } from "./footer-dp/footer-dp.component";
import { CommonDirectiveModule } from "src/directive/common-directive.module";
import { EnvironmentSelectComponent } from "./environments-select/environment-select.component";
import { CircularSliderComponent } from "./circular-slider/circular-slider.component";
import { FilterAlarmsHistoryComponent } from "../filter components/filter-alarms-history/filter-alarms-history.component";
import { EnvironmentAddDeviceComponent } from "./environment-add-device/environment-add-device.component";
import { EditSinapsiKnownDeviceComponent } from "./edit-sinapsi-known-device/edit-sinapsi-known-device";
import { FilterListQuotesComponent } from "../filter components/filter-list-quotes/filter-list-quotes.component";
import { filter } from "rxjs/operators";
import { QuoteComponent } from "./quote/quote.component";
import { BillComponent } from "./bill/bill-component";
import { FilterListBillsComponent } from "../filter components/filter-list-bills/filter-list-bills.component";
import { ResidentComponent } from "./resident/resident-component";
import { CodeEditorComponent } from "./code-editor/code-editor.component";
import { WeeklyPlanningsListComponent } from "./weekly-plannings-list/weekly-plannings-list.component";
import { WeeklyPlanningItemComponent } from "./weekly-planning-item/weekly-planning-item.component";
import { WeeklyPlanningFormComponent } from "./weekly-planning-form/weekly-planning-form.component";
import { WeeklyPlanningSingleDayComponent } from "./weekly-planning-single-day/weekly-planning-single-day.component";
import { DayPeriodChangeComponent } from "./day-period-change/day-period-change.component";
import { SelectFieldComponent } from "./select-field/select-field.component";
import {
  IonicSelectableAddItemTemplateDirective,
  IonicSelectableCloseButtonTemplateDirective,
  IonicSelectableComponent,
  IonicSelectableFooterTemplateDirective,
  IonicSelectableIconTemplateDirective,
  IonicSelectableItemTemplateDirective,
  IonicSelectablePlaceholderTemplateDirective,
  IonicSelectableSearchFailTemplateDirective,
  IonicSelectableTitleTemplateDirective,
  IonicSelectableValueTemplateDirective,
} from "ionic-selectable";

@NgModule({
  declarations: [
    PlantListComponent,
    BuildingListComponent,
    NoContentComponent,
    PlantComponent,
    BuildingComponent,
    LoginAccessPlantComponent,
    LoaderCircularComponent,
    ToggleWithTextComponent,
    IpVerificationStatusComponent,
    HomeAsideContentComponent,
    SupervisionComponent,
    DefaultSupervisionComponent,
    NumericKeypadComponent,
    MenuWebComponent,
    MenuWebDigitalPlaceComponent,
    SearchComboComponent,
    FooterComponent,
    WeekDayChooseComponent,
    OptionsPlantSpecificComponent,
    ReporthtmlListComponent,
    ReporthtmlComponent,
    ReporthtmlFormComponent,
    AccountingEntitiesListComponent,
    AccountingNotesListComponent,
    AccountingGenerateComponent,
    StructureTableAnagraphComponent,
    LoadControlListComponent,
    LoadControlFormComponent,
    LoadControlGroupFormComponent,
    LoadFormComponent,
    ListEnvironmentOpenDoorComponent,
    OptionsLogComponent,
    OptionsSettingsGenericComponent,
    DeletedContentComponent,
    OptionsVersionComponent,
    GaugeCircularComponent,
    EnvironmentSearchComponent,
    AddressesForwardListComponent,
    CommunicationListComponent,
    AddressSearchComponent,
    TimeSelectorComponent,
    WarningDeviceAdminPasswordComponent,
    InfoPopupAlarmComponent,
    GeneralInfoPopupAlarmComponent,
    ListAlarmsComponent,
    AlarmsHistoryListComponent,
    ItemHistoryListComponent,
    ItemNotificationListComponent,
    TreeNodeComponent,
    GenericTableComponent,
    ReservationStateIconComponent,
    HistoryAccessStateIconComponent,
    EnvironmentItemComponent,
    FooterDPComponent,
    EnvironmentSelectComponent,
    CircularSliderComponent,
    FilterAlarmsHistoryComponent,
    EnvironmentAddDeviceComponent,
    EditSinapsiKnownDeviceComponent,
    FilterListQuotesComponent,
    BillComponent,
    ResidentComponent,
    QuoteComponent,
    FilterListBillsComponent,
    CodeEditorComponent,
    WeeklyPlanningsListComponent,
    WeeklyPlanningItemComponent,
    WeeklyPlanningFormComponent,
    WeeklyPlanningSingleDayComponent,
    DayPeriodChangeComponent,
  ],
  imports: [
    ErrorContentComponent,
    ToolbarDPComponent,
    EmptyStateComponent,
    SelectFieldComponent,
    CommonModule,
    FormsModule,
    IonicComponentsModule,
    ReactiveFormsModule,
    TranslatePipe, TranslateDirective,
    PipesModule,
    ColorPickerDirective,
    NgxEchartsModule,
    EditorModule,
    NgxDatatableModule,
    CommonDirectiveModule,
    FilteComponentsModule,
    FormComponentModule,
    MatExpansionModule,
    ListSelectableModule,
    IonicSelectableComponent,
    IonicSelectableAddItemTemplateDirective,
    IonicSelectableCloseButtonTemplateDirective,
    IonicSelectableFooterTemplateDirective,
    IonicSelectableIconTemplateDirective,
    IonicSelectableItemTemplateDirective,
    IonicSelectablePlaceholderTemplateDirective,
    IonicSelectableSearchFailTemplateDirective,
    IonicSelectableTitleTemplateDirective,
    IonicSelectableValueTemplateDirective,
  ],
  exports: [
    PlantListComponent,
    BuildingListComponent,
    NoContentComponent,
    ErrorContentComponent,
    PlantComponent,
    BuildingComponent,
    LoginAccessPlantComponent,
    LoaderCircularComponent,
    ToggleWithTextComponent,
    IpVerificationStatusComponent,
    HomeAsideContentComponent,
    SupervisionComponent,
    DefaultSupervisionComponent,
    NumericKeypadComponent,
    MenuWebComponent,
    MenuWebDigitalPlaceComponent,
    SearchComboComponent,
    FooterComponent,
    WeekDayChooseComponent,
    OptionsPlantSpecificComponent,
    ReporthtmlListComponent,
    ReporthtmlComponent,
    ReporthtmlFormComponent,
    AccountingEntitiesListComponent,
    AccountingNotesListComponent,
    AccountingGenerateComponent,
    StructureTableAnagraphComponent,
    LoadControlListComponent,
    LoadControlFormComponent,
    LoadControlGroupFormComponent,
    LoadFormComponent,
    ListEnvironmentOpenDoorComponent,
    OptionsLogComponent,
    OptionsSettingsGenericComponent,
    DeletedContentComponent,
    OptionsVersionComponent,
    GaugeCircularComponent,
    EnvironmentSearchComponent,
    AddressesForwardListComponent,
    CommunicationListComponent,
    AddressSearchComponent,
    TimeSelectorComponent,
    WarningDeviceAdminPasswordComponent,
    InfoPopupAlarmComponent,
    GeneralInfoPopupAlarmComponent,
    ListAlarmsComponent,
    AlarmsHistoryListComponent,
    ItemHistoryListComponent,
    ItemNotificationListComponent,
    TreeNodeComponent,
    GenericTableComponent,
    ReservationStateIconComponent,
    FilteComponentsModule,
    HistoryAccessStateIconComponent,
    EnvironmentItemComponent,
    ToolbarDPComponent,
    FooterDPComponent,
    EnvironmentSelectComponent,
    CircularSliderComponent,
    FilterAlarmsHistoryComponent,
    EnvironmentAddDeviceComponent,
    EditSinapsiKnownDeviceComponent,
    FilterListQuotesComponent,
    BillComponent,
    ResidentComponent,
    QuoteComponent,
    FilterListBillsComponent,
    CodeEditorComponent,
    WeeklyPlanningsListComponent,
    WeeklyPlanningItemComponent,
    WeeklyPlanningFormComponent,
    WeeklyPlanningSingleDayComponent,
    DayPeriodChangeComponent,
    IonicSelectableComponent,
    IonicSelectableAddItemTemplateDirective,
    IonicSelectableCloseButtonTemplateDirective,
    IonicSelectableFooterTemplateDirective,
    IonicSelectableIconTemplateDirective,
    IonicSelectableItemTemplateDirective,
    IonicSelectablePlaceholderTemplateDirective,
    IonicSelectableSearchFailTemplateDirective,
    IonicSelectableTitleTemplateDirective,
    IonicSelectableValueTemplateDirective,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class GeneralComponentsModule {}
